import { useState } from "react";
import { useSeo } from "@/lib/seo";
import { SignupForm } from "@/components/SignupForm";
import { SIGNUP } from "@/constants/testIds";

const GUIDES = {
  dog: { label: "New dog guide", covers: "The supply run, decompression week, crate training that isn't cruel, the day-3 regression nobody warns you about, and the exact shopping list." },
  cat: { label: "New cat guide", covers: "Safe-room setup, litter box math (n+1, trust us), the hunt-play-feed rhythm, slow-blink diplomacy, and why they'll ignore the bed but love the box." },
};

export default function GuidePage() {
  useSeo({ title: "Free Kiddee Toy & Treat Guide for Dogs and Cats | PetTok Shop", description: "Get the free Kiddee guide: the toughest toys, healthiest treats and best gear for your dog or cat, plus 10% off your first order.", path: "/guide" });
  const [kind, setKind] = useState("dog");
  return (
    <main data-testid={SIGNUP.guidePage} className="pt-32 pb-10 max-w-5xl mx-auto px-6 lg:px-10">
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E06D44]">Free download</span>
      <h1 className="font-heading mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">The First 30 Days. No BS.</h1>
      <p className="mt-5 max-w-2xl text-stone-600 text-base md:text-lg">The checklist nobody hands you when you bring home a new dog or cat. Supplies, schedule, mistakes to skip. Written by us, reviewed by Kiddee.</p>
      <div className="mt-12 grid md:grid-cols-2 gap-8 items-start">
        <div className="bg-[#1C1917] text-white rounded-[2rem] p-8">
          <div className="flex gap-2 bg-white/10 p-1 rounded-full w-fit">
            {Object.entries(GUIDES).map(([k, g]) => (
              <button key={k} data-testid={SIGNUP.guideTab(k)} onClick={() => setKind(k)} className={`px-4 py-2 rounded-full text-sm transition-colors ${kind === k ? "bg-white text-[#1C1917]" : "text-white/80 hover:text-white"}`}>{g.label}</button>
            ))}
          </div>
          <p className="mt-6 text-white/80">Get the guide plus a 10% off code. No spam, we're too busy packing treats.</p>
          <div className="mt-6"><SignupForm key={kind} source={`guide-${kind}`} cta={`Get the ${GUIDES[kind].label.toLowerCase()}`} /></div>
        </div>
        <div className="space-y-6">
          {Object.entries(GUIDES).map(([k, g]) => (
            <div key={k} className="bg-white border border-[#F0EBE1] rounded-[1.5rem] p-6">
              <h2 className="font-heading text-xl font-bold">{k === "dog" ? "Dog" : "Cat"} version covers</h2>
              <p className="mt-3 text-stone-600">{g.covers}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
